<!-- src/views/DashboardView.vue -->
<template>
  <div class="row">
    <div class="col-md-12">
      <div ref="carousel" class="carousel">
        <div
          v-for="banner in banners"
          :key="banner.id"
          class="carousel-cell"
          @click="navigateBanner(banner)"
        >
          <img
            :src="getBannerImage(banner)"
            class="banner-img"
            @error="handleImageError"
          />
        </div>
      </div>
    </div>
  </div>
  <br />
</template>

<script>
import Flickity from "flickity";
import "flickity/css/flickity.css";
import { apiUrl } from "@/utils/api";

export default {
  name: "bannersHome",
  data() {
    return {
      banners: [],
      defaultImage: "/assets/img/acad-icon.png",
    };
  },
  computed: {
    isRtl() {
      return this.$i18n.locale === "ar";
    },
  },
  async mounted() {
    await this.fetchBanners();

    this.$nextTick(() => {
      const carouselElement = this.$refs.carousel;
      if (carouselElement) {
        new Flickity(carouselElement, {
          contain: true,
          autoPlay: true,
          wrapAround: true,
          cellAlign: this.isRtl ? "right" : "left",
          rightToLeft: this.isRtl,
        });
      }
    });
  },
  methods: {
    async fetchBanners() {
      try {
        const response = await fetch(`${apiUrl}/scholarships/banners`, {
          method: "GET",
          headers: {
            "x-country-code": window.appRegion.phone_code,
          },
        });
        const jsonResponse = await response.json();
        // ✅ تعديل: البيانات أصبحت داخل data
        this.banners = jsonResponse.data || [];
      } catch (error) {
        console.error("Error fetching banners:", error);
      }
    },

    getBannerImage(banner) {
      if (!banner.image_url) return this.defaultImage;
      return banner.image_url;
    },
    handleImageError(e) {
      e.target.src = this.defaultImage;
    },
    navigateBanner(banner) {
      switch (banner.type) {
        case "course":
          window.open(`/course-details?id=${banner.type_id}`, "_blank");
          break;

        case "bundle":
          window.open(`/bundle-details?id=${banner.type_id}`, "_blank");
          break;

        case "instructor":
          window.open(`/instructor-profile?id=${banner.type_id}`, "_blank");
          break;

        case "scholarship":
          // Navigate to scholarship details page
          if (banner.type_id) {
            window.location.href = `/scholarship-details?id=${banner.type_id}`;
          } else if (banner.external_url) {
            window.open(banner.external_url, "_blank");
          }
          break;

        case "external":
          if (banner.external_url) {
            window.open(banner.external_url, "_blank");
          }
          break;
      }
    },
  },
};
</script>

<style scoped>
.carousel {
  height: 280px;
}

.carousel-cell {
  width: calc(100% - 12px);
  margin-right: 12px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

@media (min-width: 768px) {
  .carousel {
    height: 320px;
  }
}

@media (min-width: 992px) {
  .carousel {
    height: 360px;
  }
  .carousel-cell {
    width: calc(50% - 12px);
  }
}

.banner-img {
  width: 96%;
  height: 100%;
  object-fit: cover;
  border-radius: 14px;
  transition: transform 0.35s ease, box-shadow 0.35s ease, filter 0.35s ease;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
  border: 2px solid #eaf9f0;
  box-shadow: inset 0 0 0 2px rgba(0, 196, 68, 0.08),
    0 6px 16px rgba(0, 0, 0, 0.08);
}

.carousel-cell:hover .banner-img {
  transform: scale(1.025);
  box-shadow: inset 0 0 0 2px rgba(0, 196, 68, 0.18),
    0 14px 28px rgba(0, 196, 68, 0.25);
  filter: saturate(1.02) contrast(1.02);
}

/* Flickity dots styled to brand */
:deep(.flickity-page-dots .dot) {
  background: #bfeecf;
  opacity: 1;
}
:deep(.flickity-page-dots .dot.is-selected) {
  background: #00c444;
}

/* Flickity arrows */
:deep(.flickity-prev-next-button) {
  background: rgba(0, 196, 68, 0.12);
  color: #00c444;
}
:deep(.flickity-prev-next-button:hover) {
  background: rgba(0, 196, 68, 0.2);
}
</style>
